import {
  MARKUP_RESET_FILTER,
  MARKUP_SET_FILTER,
  MARKUP_ENABLE_LOADING,
  MARKUP_DISABLE_LOADING,
  MARKUP_FETCH_DATA,
  MARKUP_FETCH_ERROR,
} from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  markupData: [],
  filteredMarkupData: [],
  filterSelected: {
    status: 'ALL',
  },
  filteredDataByShippers: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {

    case MARKUP_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
        markupData: [],
        filteredMarkupData: [],
        filterSelected: {
          status: 'ALL',
        },
        filteredDataByShippers: [],
      };
    }

    case MARKUP_SET_FILTER: {
      return {
        ...state,
        filteredMarkupData: action.data,
        filteredDataByShippers: action.filteredDataByShippers,
        filterSelected: {
          ...state.filterSelected,
          ...action.filter,
        },
      };
    }

    case MARKUP_DISABLE_LOADING : {
      return {
        ...state,
        isLoading : false,
      };
    }

    case MARKUP_RESET_FILTER: {
      return {
        ...state,
        filteredMarkupData: action.data,
        filterSelected: defaultState.filterSelected,
        filteredDataByShippers: action.data,
      };
    }

    case MARKUP_FETCH_DATA: {
      return {
        ...state,
        errorMessage: undefined,
        markupData: action.data,
        filteredMarkupData: action.data,
        filteredDataByShippers: action.data,
      };
    }

    case MARKUP_FETCH_ERROR: {
      return {
        ...state,
        errorMessage: action.data,
      };
    }
    default: return state;
  }
};
